var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "copy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0833 5.25C11.7277 5.25 12.25 5.77232 12.25 6.41667V11.0833C12.25 11.7277 11.7277 12.25 11.0833 12.25H6.41667C5.77232 12.25 5.25 11.7277 5.25 11.0833V6.41667C5.25 5.77232 5.77232 5.25 6.41667 5.25H11.0833ZM1.75 2.91667V7.58333C1.75 8.22768 2.27232 8.75 2.91667 8.75H4.375V6.41667C4.375 5.29101 5.29101 4.375 6.41667 4.375H8.75V2.91667C8.75 2.27232 8.22768 1.75 7.58333 1.75H2.91667C2.27232 1.75 1.75 2.27232 1.75 2.91667ZM10.7917 9.33333C10.9527 9.33333 11.0833 9.46392 11.0833 9.625C11.0833 9.78608 10.9527 9.91667 10.7917 9.91667H6.70833C6.54725 9.91667 6.41667 9.78608 6.41667 9.625C6.41667 9.46392 6.54725 9.33333 6.70833 9.33333H10.7917ZM10.7917 7.58333H6.70833C6.54725 7.58333 6.41667 7.71392 6.41667 7.875C6.41667 8.03608 6.54725 8.16667 6.70833 8.16667H10.7917C10.9527 8.16667 11.0833 8.03608 11.0833 7.875C11.0833 7.71392 10.9527 7.58333 10.7917 7.58333Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.1c02fa678f17f7fa45c4d4bde08477eb.svg";
export { ForwardRef as ReactComponent };